// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nsxwA","newExpiryDate":"styles_newExpiryDate__lSBVy","footer":"styles_footer__iXtAo"};